import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";


export class MapAddonGroupModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._active = false;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapAddonGroupModel());
        } else if (target instanceof MapAddonGroupModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MapAddonGroupModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _active: alias("active", Schema.primitive())
});